import Header from './Header.component';

export * from './Header.styled';
export default Header;
